export const TOOL_TYPE = {
  Audio: 0,
  Book: 1,
  BOV: 2,
};
